import { AudioLines } from 'lucide-react';
import { useParams } from 'react-router-dom';

import { HealthCheckList } from '@/components/health/HealthCheckList';
import { HealthRowActions } from '@/components/health/HealthRowActions';
import { useHealthCheck } from '@/hooks/useHealthCheck';

/**
 * Greater-area-scoped "Descriptions & Voiceovers" health view.
 */
export function GreaterAreaHealthContentTab() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useHealthCheck('greaterArea', 'content', id);

  return (
    <HealthCheckList
      data={data?.data}
      isLoading={isLoading}
      IconAllClear={AudioLines}
      allClearTitle="All descriptions and voiceovers ready"
      allClearDescription="Every primary, theme, and translation in this area has a description and an in-sync voiceover."
      emptyTitle="No content to check"
      emptyDescription="Add attractions to this area to surface description and voiceover gaps here."
      renderRowActions={(row) => <HealthRowActions row={row} />}
    />
  );
}
